import { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';

import { database } from '../firebaseConfig';
import { ref, push, runTransaction } from "firebase/database";

import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

import { SnapshotVal, IdValue, TagValue } from '../FirebaseType';

import DeleteModal from './DeleteModal';
import ListSortable from './ListSortable';

import { addItem } from '../util/Firebase';

type Inputs = {
  id: string;
  name: string;
};

interface SettingTagProps {
  list: IdValue<TagValue>[] | undefined;
  loginUserUid: string;
}

function SettingTag(props: SettingTagProps) {
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<IdValue<TagValue>>();

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    reset,
    formState: { errors }
  } = useForm<Inputs>({
    defaultValues: {
      id: "",
      name: ""
    }
  });

  const watchId = watch('id');

  const onSubmit: SubmitHandler<Inputs> = (data) => {
    runTransaction(ref(database, "/v3/" + props.loginUserUid + "/tag"), (post: SnapshotVal<TagValue>) => {
      if(!post) post = {};

      if(watchId) {
        post[watchId].name = getValues('name');
      }
      else {
        const key = push(ref(database, "/v3/" + props.loginUserUid + "/tag")).key || '';
        addItem<SnapshotVal<TagValue>>(post, key, {
          name: getValues('name'),
          sortNumber: 0
        })
      }

      return post;
    });
    reset();
  }

  const onCancel = () => {
    reset();
  };

  const onEdit = (id: IdValue<TagValue>) => {
    setValue('id', id.id);
    setValue('name', id.value.name);
  };

  const onDelete = (id: IdValue<TagValue>) => {
    setShowDeleteModal(true);
    setDeleteId(id);
  };

  return (
    <>
      <h5>タグ</h5>
      <hr />
      {props.loginUserUid &&
        <Form className="mb-3" onSubmit={handleSubmit(onSubmit)}>
          {watchId &&
            <Alert variant="warning">修正中です</Alert>
          }
          <Row className="d-flex align-items-end flex-wrap">
            <Col xs={7}>
              <Form.Group>
                <Form.Label>名前</Form.Label>
                <Form.Control
                  type="text"
                  isInvalid={!!errors.name}
                  {...register('name', {
                    required: '必須項目です'
                  })} />
                <Form.Control.Feedback type="invalid">{errors.name?.message}</Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col className="pt-2" xs={5}>
              <Button type="submit" variant="primary" size="sm" className="mt-lg-4 mt-1 me-1">登録</Button>
              <Button variant="secondary" size="sm" className="mt-lg-4 mt-1 me-1" onClick={onCancel}>キャンセル</Button>
            </Col>
          </Row>
        </Form>
      }

      {!props.list && <p>Loading...</p>}

      {props.list &&
        <ListSortable<TagValue>
          list={props.list}
          databasePath={"/v3/" + props.loginUserUid + "/tag"}
          columnWidthLg={[1, 6, 5]}
          columnWidthXs={[1, 6, 5]}
          columnJSX={[
            (item) => <>{item.value.name}</>
          ]}
          onEdit={onEdit}
          editingId={watchId}
          onDelete={onDelete}
        />
      }

      <DeleteModal<TagValue>
        showDeleteModal={showDeleteModal}
        setShowDeleteModal={setShowDeleteModal}
        deleteId={deleteId}
        setDeleteId={setDeleteId}
        databasePath={"/v3/" + props.loginUserUid + "/tag"}
      />
    </>
  );
}

export default SettingTag;